var exports = {
  "ZH": "GuildBadge.module__badgeWrapper___Ui12Wm",
  "qS": "GuildBadge.module__badge___Ui12Wm",
  "eT": "GuildBadge.module__badgeOnLightSurface___Ui12Wm",
  "YW": "GuildBadge.module__badgeBanner___Ui12Wm",
  "e$": "GuildBadge.module__badgeBannerDark___Ui12Wm",
};

module.exports = exports;
